export const alarmingEmojis = [
  "🤤",
  "🦏",
  "🌭",
  "🍌",
  "🥕",
  "🌮",
  "🍩",
  "✌",
  "🍑",
  "👄",
  "💋",
  "👅",
  "💦",
  "🤤",
  "🍒",
  "🍆",
  "👌",
  "👆",
  "👉",
  "👇",
  "☝",
  "👈",
  "👇",
  "🔥",
  "⚡",
  "✂️",
  "🐫",
  "🐪",
  "🚿😉",
  "🚿😏",
  "😈",
  "👿",
  "🔨",
  "🦴",
  "🍣",
  "🥟",
  "🥠",
  "♋"
];
